// for LOCAL-ONLY TWO TIER - separate front end & backend
// export const serverEndPoint = "http://localhost:8080/api/";

// for SERVER+LOCAL TWO TIER - separate front end & backend
// export const serverEndPoint = process.env.REACT_APP_API_ENDPOINT;
// export const localEndPoint = process.env.REACT_APP_SILZILA_WEBSITE_BASE_URL;
export const serverEndPoint = import.meta.env.VITE_API_ENDPOINT;
export const localEndPoint = import.meta.env.VITE_SILZILA_WEBSITE_BASE_URL;
//export const localEndPoint='http://localhost:5500/';
// export const qaEndPoint = 'app.qa.silzila.com/api/';
// for LOCAL-ONLY SINGLE TIER - single build with react app
// export const serverEndPoint = "http://localhost:8080/";

export const websiteAddress = 'https://silzila.org';
export const githubAddress = 'https://github.com/silzila/silzila';
export const githubIssueAddress = 'https://github.com/silzila/silzila/issues';
